import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';
import { UtilityService } from '@app/core/utility/utility.service';
import { BaseService } from '@core/base/base.service';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { WMLConstructorDecorator, generateClassPrefix, generateIdPrefix } from '@windmillcode/wml-components-base';
import { ENV } from '@env/environment';
import { JobsZeroCommonProps } from '../jobs-zero/jobs-zero';

@Component({
    selector: 'backup-previous-state-job-zero',
    templateUrl: './backup-previous-state-job-zero.component.html',
    styleUrls: ['./backup-previous-state-job-zero.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BackupPreviousStateJobZeroComponent {
  classPrefix = generateClassPrefix('BackupPreviousStateJobZero');
  idPrefix = generateIdPrefix(ENV.idPrefix.backupPreviousStateJobZero);

  @Input('props') props: BackupPreviousStateJobZeroProps = new BackupPreviousStateJobZeroProps();
  @HostBinding('class') myClass: string = this.classPrefix(`View`);
  @HostBinding('id') myId: string = this.idPrefix();

  ngUnsub = new Subject<void>();

  constructor(
    public cdref: ChangeDetectorRef,
    public utilService: UtilityService,
    public baseService: BaseService
  ) {}

  listenForUpdate = () => {
    return this.props.updateSubj.pipe(
      takeUntil(this.ngUnsub),
      tap((res?) => {
        this.props = new BackupPreviousStateJobZeroProps({
          ...this.props,
          ...(res ?? this.props)
        });
        this.cdref.detectChanges();
      })
    );
  }

  ngOnInit(): void {
    this.listenForUpdate().subscribe();
  }

  ngOnDestroy() {
    this.ngUnsub.next();
    this.ngUnsub.complete();
  }
}

@WMLConstructorDecorator
export class BackupPreviousStateJobZeroProps extends JobsZeroCommonProps {
  constructor(props: Partial<BackupPreviousStateJobZeroProps> = {}) {super();}
  updateSubj = new Subject<BackupPreviousStateJobZeroProps>();

}
